import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import PlayerHeadshot from '~/components/PlayerHeadshot/PlayerHeadshot';
import get from 'lodash/get';
import css from './PenaltyCard.scss';

/* eslint-disable react/prefer-stateless-function */
const getPlayerShortName = player => get(player, 'first_initial_and_last_name', '');
const getPlayerFullName = player => get(player, 'full_name', '');
const getPlayerName = player => {
  const name = getPlayerFullName(player);
  if (!name || name.length >= 15) {
    return getPlayerShortName(player);
  }
  return name;
};
const getTeamLogo = penalty => get(penalty, 'team.logos.small', '');
const getPenaltyPlayerName = penalty => {
  if (penalty.player) {
    return getPlayerName(get(penalty, 'player', {}));
  }

  return penalty.team.medium_name;
};

class PenaltyCard extends React.Component {
  render() {
    const { penalty } = this.props;

    /* prettier-ignore */
    return (
      <div key="penalty" className={css.penaltyCard}>
        <div className={css.playerInfo}>
          <PlayerHeadshot player={penalty.player} size={'small'} team={penalty.team} />
          <div className={css.playerText}>
            <div className={css.playerTextInnerContainer}>
              <img alt="" className={css.teamLogo} src={getTeamLogo(penalty)} />
              <div className={css.playerName}>
                <div className={css.scorer}>{getPenaltyPlayerName(penalty)}</div>
              </div>
            </div>
            <div className={css.penalty}>
              {penalty.severity} - {penalty.penalty} - {penalty.length_in_minutes} minutes
            </div>
          </div>
        </div>

        <div className={css.time}>
          {penalty.minute}:{penalty.second > 9 ? '' : '0'}
          {penalty.second}
        </div>
      </div>
    );
  }
}

PenaltyCard.displayName = 'PenaltyCard';

PenaltyCard.propTypes = {
  penalty: PropTypes.object.isRequired,
};

export default StyledComponent(PenaltyCard, [css]);
